import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IHomePage_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IHomePage_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  Connect: any;
  Connect_dummy: any;
  GetMainPageSummary: any[];
  GetMainPageSummary_dummy: any[];
  GetImage: any[];
  GetImage_dummy: any[];
  isComp171088Visible: "visible" | "hidden";
  isComp632894Visible: "visible" | "hidden";
  isComp698701Visible: "visible" | "hidden";
  isComp303852Visible: "visible" | "hidden";
  isComp480837Visible: "visible" | "hidden";
}

export class HomePage_ScreenBase extends React.PureComponent<
  IHomePage_ScreenProps,
  any
> {
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "488aaeba-8813-4e2a-8619-9f33f6c9a0ad",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 802090, PropertyName: "label", Value: "Profil" },
        { Id: 980788, PropertyName: "label", Value: "Çıkış Yap" },
        { Id: 35731, PropertyName: "value", Value: "Merhaba," },
        { Id: 240176, PropertyName: "value", Value: "Kasa Hesapları" },
        { Id: 426738, PropertyName: "value", Value: "Cari Hesapları" },
        { Id: 3063, PropertyName: "value", Value: "Tedarikçi Hesapları" },
        { Id: 426066, PropertyName: "value", Value: "Banka Hesapları" },
        { Id: 298501, PropertyName: "value", Value: "Borç Çek Senetleri" },
        { Id: 859968, PropertyName: "value", Value: "Borç Çeki" },
        { Id: 311903, PropertyName: "value", Value: "Borç Seneti" },
        { Id: 179016, PropertyName: "value", Value: "Alacak Çek Senetleri" },
        { Id: 539896, PropertyName: "value", Value: "Alacak Çek" },
        { Id: 60440, PropertyName: "value", Value: "Alacak Senet" },
        { Id: 584282, PropertyName: "value", Value: "Hızlı Erişim" },
        { Id: 168442, PropertyName: "value", Value: "Alış Faturaları" },
        { Id: 548078, PropertyName: "value", Value: "Kasa" },
        { Id: 573260, PropertyName: "value", Value: "Mağaza Ciro Analizi" },
        { Id: 365163, PropertyName: "value", Value: "Ürün Satış Analizi" },
        { Id: 345049, PropertyName: "value", Value: "Kredi Kartı İşlemleri" },
        { Id: 776280, PropertyName: "value", Value: "Masraf Faturaları" },
        { Id: 274413, PropertyName: "value", Value: "Satış Faturları" },
        { Id: 790563, PropertyName: "value", Value: "Ürün Envanter Analizi" },
        { Id: 36025, PropertyName: "value", Value: "Ürün Maliyet Analizi" },
        { Id: 859146, PropertyName: "value", Value: "Müsteri Hesapları" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Logout: false,
      goToSignInActivity: "",
      Connect: "",
      GetMainPageSummary: [],
      GetImage: [],
      isComp171088Visible: "hidden",
      isComp632894Visible: "hidden",
      isComp698701Visible: "hidden",
      isComp303852Visible: "hidden",
      isComp480837Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("homepage", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.HomePagePageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("homepage", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("homepage", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.HomePagePageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      homepage_14015_value: this.state.GetImage?.at?.(0)?.photo ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  HomePagePageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HomePage/HomePagePageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetMainPageSummary = result?.data.getMainPageSummary;
    formVars.homepage_675742_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].cashBalance
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].cashBalance
        : null
    );
    formVars.homepage_395120_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].customerBalance
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].customerBalance
        : null
    );
    formVars.homepage_812676_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].vendorBalance
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].vendorBalance
        : null
    );
    formVars.homepage_279833_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].bankBalance
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].bankBalance
        : null
    );
    formVars.homepage_319848_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].debitCheques
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].debitCheques
        : null
    );
    formVars.homepage_182548_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].debitNote
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].debitNote
        : null
    );
    formVars.homepage_614624_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].creditCheques
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].creditCheques
        : null
    );
    formVars.homepage_196493_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].creditNote
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].creditNote
        : null
    );
    stateVars.GetImage = result?.data.getImage;
    formVars.homepage_14015_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagePageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePagePageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.homepage_14015_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );

    formVars.homepage_675742_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].cashBalance
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].cashBalance
        : null
    );

    formVars.homepage_395120_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].customerBalance
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].customerBalance
        : null
    );

    formVars.homepage_812676_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].vendorBalance
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].vendorBalance
        : null
    );

    formVars.homepage_279833_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].bankBalance
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].bankBalance
        : null
    );

    formVars.homepage_319848_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].debitCheques
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].debitCheques
        : null
    );

    formVars.homepage_182548_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].debitNote
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].debitNote
        : null
    );

    formVars.homepage_614624_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].creditCheques
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].creditCheques
        : null
    );

    formVars.homepage_196493_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].creditNote
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].creditNote
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  HomePageComponent_557324_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "316786",
      null,
      "left",
      "true",
      "100vw",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_802090_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "ProfileScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_980788_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_752361_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "AlisFatura",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_261980_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "KasaList",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_495004_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "MagazaCiroAnalizi",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_573818_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "UrunSatisAnaliz",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_698571_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "KrediKartiList",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_261736_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "MasrafList",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [316786, , , , , , ,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.HomePagePageInit();
    }
  }
}
